import { isEqual } from "date-fns";
import React from "react";
import { RCCBadge, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import formatLink from "src/utils/formatLink";
import { ICardOfMeetings } from "../../interface";
import { DivIcons, DivWithWrap, StyledMeetingCard } from "./styles";

const MeetingCard: React.FC<ICardOfMeetings> = ({
	data,
	options
}) => {

	const { translate,currentLanguage} = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	const situationProp = (prop:"color"|"text") => {
		const props = {
			color:data.ara001Finalizada === "S" ? "green" : "red",
			text:data.ara001Finalizada === "S" ? translate("Finalizada") : translate("Não finalizada")
		};

		return props[prop] as any;
	};

	return (
		<StyledMeetingCard
			color={situationProp("color")}
			options={options(data)}
			title={data.ara001Assunto}
			hidePercentage
		>
			<RCCGrid container item alignItems="center">
				<DivWithWrap style={{marginRight: "0.5rem"}}>
					<Photo 
						name={data.ara001Efa005Nome}
						link={data.ara001Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.ara001Efa005Imagem}`}
						hover
					/>
					{data.ara001Efa005Nome}
				</DivWithWrap>
				<DivWithWrap style={{ flexDirection: "column", alignItems: "baseline" }}>
					<DivWithWrap>
						<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
						{
							isEqual(new Date(data.ara001Dthrinicio),new Date(data.ara001Dthrfim)) ?
								<span>{formatDate(data.ara001Dthrinicio,currentLanguage,true)}</span>
								:
								<span>{formatDate(data.ara001Dthrinicio,currentLanguage,true)} - {formatDate(data.ara001Dthrfim,currentLanguage,true,"dd/MM/yyyy")}</span>
						}
					</DivWithWrap>
				</DivWithWrap>	
				
			</RCCGrid>

			<p><b>{`${translate("Sala")}: `}</b> {data.taa008Descricao}</p>
			
			{data.taa010Descricao &&
				(<p><b>{`${translate("Tipo")}:`}</b>{data.taa010Descricao}</p>)
			}
			<DivWithWrap>
				<RCCBadge 
					color={situationProp("color")}
					styleInline="font-size: 0.83rem;"
				>
					{situationProp("text")}
				</RCCBadge>
				{data.ara001Linkexterno && (
					<DivIcons 
						onClick={() => {
							window.open(formatLink(data.ara001Linkexterno as string), "_blank");
						}}
					>
						<RCCTooltip 
							text={translate("Link")}
						>
							<RCCIcon name="linkExternal" size={16}/>
						</RCCTooltip>
					</DivIcons>
				)}
			</DivWithWrap>
		</StyledMeetingCard>	
	);

};

export default MeetingCard;
